import {
  alpha,
  Checkbox,
  inputClasses,
  inputLabelClasses,
  TextField,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";

export default function CheckComponent({
  field,
  variant,
  index,
  defaultChecked = false,
  containerId,
  fieldId,
}) {
  const [currentChecked, setCurrentChecked] = useState(defaultChecked);
  useEffect(() => {
    setCurrentChecked(!!defaultChecked);
  }, [defaultChecked]);
  const theme = useTheme();
  return (
    <TextField
      id={containerId}
      variant={variant}
      fullWidth
      {...(field.hidden ? { style: { width: 0, height: 0 } } : {})}
      key={index}
      // onChange={(e) => e.preventDefault()}
      placeholder={field.label}
      label={`${field.label}${field.required ? "*" : ""}`}
      value={currentChecked ? "Activo" : "Inactivo"}
      disabled={!!field.readOnly}
      InputLabelProps={{
        sx: {
          // set the color of the label when not shrinked
          color: "gray",
          padding: "20px 18px",
          fontSize: 20,

          [`&.${inputLabelClasses.shrink}`]: {
            // set the color of the label when shrinked (usually when the TextField is focused)
            padding: "6px 24px",
            lineHeight: 1,
          },
        },
      }}
      InputProps={{
        disableUnderline: true,
        placeholder: field.label,
        endAdornment: (
          <Checkbox
            id={fieldId}
            checked={!!currentChecked}
            onClick={(event) => {
              console.log("check", event, currentChecked);
              setCurrentChecked(!currentChecked);
            }}
            disabled={!!field.readOnly}
            style={{ position: "absolute", right: 8 }}
          />
        ),
        sx: {
          padding: "12px 18px",
          backgroundColor: alpha(theme.palette.primary.light, 0.05),
          boxShadow: "0px 0px 2px gray",
          borderRadius: "30px",
          fontSize: 20,
          [`&.${inputClasses.focused}`]: {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
          },
        },
      }}
      sx={{
        paddingTop: 1,
      }}
      inputProps={{
        readOnly: true,
        inputMode: field.numeric ? "numeric" : "text",
        pattern: "[0-9]*",
      }}
    />
  );
}
